import { __generator } from "tslib";
import { call, select, delay } from 'redux-saga/effects';
import { getGallectionById } from '../selectors';
import { request } from '../../xhr';
import { getGallectionType } from '../helpers';
function setGallectionName(action) {
    var _a, folderId, name, gallection, params;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, delay(500)];
            case 1:
                _c.sent(); // + takeLatest = debounced
                _a = action.payload, folderId = _a.folderId, name = _a.name;
                return [4 /*yield*/, select(getGallectionById, folderId)];
            case 2:
                gallection = _c.sent();
                if (!gallection) {
                    return [2 /*return*/];
                }
                params = {
                    type: (_b = getGallectionType(gallection)) !== null && _b !== void 0 ? _b : 'collection',
                    folderid: gallection.folderId,
                    name: name,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/rename',
                        data: params,
                    })];
            case 3:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
export default setGallectionName;
//# sourceMappingURL=saveChangedGallectionName.js.map